import { checkBrowser } from 'ev-hooks/browserCheck';

// iOS Safari auto-zooms the whole page when a focused input's font-size is
// below 16px (ours are 14px), leaving the app cropped until the user pinches
// back out. maximum-scale=1 disables only that automatic zoom on iOS — pinch
// zoom still works there — but on Android it would genuinely block pinch zoom,
// so it must be applied to iOS/iPadOS devices only.
if (checkBrowser().isIosDevice) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=yes',
    );
}

export {};
